import React from "react";
import { about, hubLikha } from "../data/content";

export default function About() {
  return (
    <section id="profile" className="section-pad border-t border-rule bg-canvas-raised">
      <div className="wrap">
        <div className="grid gap-12 lg:grid-cols-12">
          <header className="reveal lg:col-span-4">
            <p className="label">02 / Engineering profile</p>
            <h2 className="mt-4 font-display text-[clamp(1.75rem,3vw,2.5rem)] font-semibold tracking-[-0.02em]">
              Software. Security. Infrastructure. Products.
            </h2>
          </header>

          <div className="reveal space-y-5 lg:col-span-8">
            {about.paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 32)} className="text-ink-secondary md:text-lg">
                {paragraph}
              </p>
            ))}

            <div className="border-t border-rule pt-6">
              <h3 className="label mb-4">After the code leaves the editor</h3>
              <ul className="grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
                {about.afterEditor.map((item) => (
                  <li
                    key={item}
                    className="font-mono text-[0.75rem] text-ink-secondary"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="border border-rule bg-canvas p-6">
              <p className="label">Lead development / product engineering</p>
              <h3 className="mt-2 font-display text-xl font-semibold">
                {hubLikha.company}
              </h3>
              <p className="mt-1 font-mono text-[0.75rem] text-ink-muted">
                {hubLikha.role} · {hubLikha.period}
              </p>
              <p className="mt-3 text-sm text-ink-secondary">{hubLikha.summary}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
